<template>
  <b-card>
    <template #header>
      <h5 class="card-title">Company Overview</h5>
    </template>
    <div class="d-flex align-items-center">              
      <template v-if="showContent">
        <b-form-checkbox @change="$emit('updateShowSection', $event, 'show-company-overview', apiGet)" id="business" value="Y" unchecked-value="N" name="checkbox" v-model="showContent">Show Section?</b-form-checkbox>
      </template>
      <b-button 
        variant="secondary"
        class="btn-rounded ml-auto"
        v-if="formOpen"
        @click="closeForm">
        Close <i class="fas fa-times ml-2"></i>
      </b-button>
      <b-button
        variant="outline-info"
        class="btn-rounded ml-auto"
        @click="showUpdateForm"
        v-else
      >
        Update Content <i class="fas fa-pencil-alt ml-2"></i>
      </b-button>

    </div>
    <hr />

    
    <validation-observer
      v-slot="{ handleSubmit }"
      ref="VFormCompanyOverview"
      tag="div"
      v-if="formOpen"
    >
      <b-form @submit.prevent="handleSubmit(doSubmit)">
        <b-card class="border mb-0">
          <template #header>
            <h5 class="card-title">Content</h5>
          </template>
          <b-row>
            <b-col md=4>
              <b-form-group label-for="glance_title">
                <label>Title <span class="text-danger mr5">*</span></label>
                <b-form-input v-model="row.asc_title"></b-form-input>
                <VValidate name="Title" v-model="row.asc_title" :rules="validation.asc_title" />
              </b-form-group>
            </b-col>

            <div class="col-md-8">
              <div class="form-group mb-2">                      
                <label>Content <strong class="text-danger">*</strong></label>
                <CKEditor 
                  ref="ourBusinessID"
                  :ready-on-focus="true"
                  :customToolbar="configCKEditor"
                  :value.sync="row.asc_content"

                />
                <VValidate 
                  name="Content" 
                  v-model="row.asc_content"
                  :rules="validation.asc_content" 
                />
              </div>
            </div>
          </b-row>
          <template #footer>
            <div class="text-right">
              <b-button variant="secondary" class="btn-rounded mr-3" @click="closeForm">Cancel</b-button>
              <button type="submit" class="btn btn-info btn-rounded">Save Changes</button>
            </div>
          </template>
        </b-card>
      </b-form>
    </validation-observer>
    <div class="row" v-else>
      <div class="col-md-12">
        <div v-html="content.asc_content"></div>
      </div>
    </div>

  </b-card>
</template>
<script>
import Gen from '@/libs/Gen.js'
import CKEditor from '@/components/CKEditor'
let _ = global._

export default {
  components: {
    CKEditor
  },
  props:{
    modulePage: String
  },
  data(){
    return {
      formOpen: false,
      content: {},
      row: {},
      configCKEditor: [ 'heading', '|', 'bold','italic','underline','strikethrough','link','bulletedList','numberedList','blockQuote'],
      validation: {},
      showContent: null,
    }
  },
  computed:{
    parent(){
      return this.$parent.$parent.$parent
    }
  },
  mounted(){
    this.apiGet()
  }, 
  methods: {
    modalVisi(value){
      this.rowAlpha = _.clone(value)
      this.$bvModal.show('modalVisi')
    },
    showUpdateForm(){
      this.formOpen = true
      this.row = _.clone(this.content)
    },
    closeForm(){
      this.formOpen = false
    },
    doSubmit(){
      this.$refs.VFormCompanyOverview.validate().then(success => {
        if(!success) return 

        this.parent.swalLoading()

        Gen.apiRest('/do/' + this.modulePage, 
            { data: { type: 'updateCompanyOverview', ...this.row } }
          ).then(res => {
            if(res){
              this.$swal({
                title: res.data.message,
                icon: 'success',
              }).then(() => {
                this.apiGet()
                this.formOpen = false
              })
            }
          }).catch(err => {
            this.$swal({title: err.response.data.message, icon:'error'})
          })
      })
    },
    apiGet(){
      Gen.apiRest('/get/' + this.modulePage +  '/company_overview', {}, 'GET').then(res => {
        this.content = res.data.row
        this.validation = res.data.validation
        this.showContent = res.data.showContent
      })
    }
  }
}
</script>
